import "core-js/modules/es.array.reverse.js";
var _class, _OpenDataSoftDatasetStratum, _class2, _OpenDataSoftCatalogItem;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { ApiClient, fromCatalog } from "@opendatasoft/api-client";
import i18next from "i18next";
import { computed, makeObservable, override, runInAction } from "mobx";
import ms from "ms";
import Mustache from "mustache";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import TimeInterval from "terriajs-cesium/Source/Core/TimeInterval";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import flatten from "../../../Core/flatten";
import isDefined from "../../../Core/isDefined";
import { isJsonObject, isJsonString } from "../../../Core/Json";
import TerriaError from "../../../Core/TerriaError";
import AutoRefreshingMixin from "../../../ModelMixins/AutoRefreshingMixin";
import TableMixin from "../../../ModelMixins/TableMixin";
import UrlMixin from "../../../ModelMixins/UrlMixin";
import TableAutomaticStylesStratum from "../../../Table/TableAutomaticStylesStratum";
import { MetadataUrlTraits } from "../../../Traits/TraitsClasses/CatalogMemberTraits";
import EnumDimensionTraits from "../../../Traits/TraitsClasses/DimensionTraits";
import OpenDataSoftCatalogItemTraits from "../../../Traits/TraitsClasses/OpenDataSoftCatalogItemTraits";
import TableColumnTraits from "../../../Traits/TraitsClasses/Table/ColumnTraits";
import TableStyleTraits from "../../../Traits/TraitsClasses/Table/StyleTraits";
import TableTimeStyleTraits from "../../../Traits/TraitsClasses/Table/TimeStyleTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import { isValidDataset } from "../CatalogGroups/OpenDataSoftCatalogGroup";
// Column name to use for OpenDataSoft Record IDs
const RECORD_ID_COL = "record_id";
export let OpenDataSoftDatasetStratum = (_class = (_OpenDataSoftDatasetStratum = class OpenDataSoftDatasetStratum extends LoadableStratum(OpenDataSoftCatalogItemTraits) {
  static async load(catalogItem) {
    var _catalogItem$timeFiel, _catalogItem$geoPoint;
    if (!catalogItem.url) throw "`url` must be set";
    if (!catalogItem.datasetId) throw "`datasetId` must be set";
    const client = new ApiClient({
      domain: catalogItem.url
    });
    const response = await client.get(fromCatalog().dataset(catalogItem.datasetId).itself());
    const dataset = response.dataset;
    if (!isValidDataset(dataset)) throw "Could not find dataset `".concat(catalogItem.datasetId, "`");

    // Try to retrieve information about geo-referenced (point or polygon/region) time-series
    let pointTimeSeries;
    const timeField = (_catalogItem$timeFiel = catalogItem.timeFieldName) !== null && _catalogItem$timeFiel !== void 0 ? _catalogItem$timeFiel : getTimeField(dataset);
    const geoPointField = (_catalogItem$geoPoint = catalogItem.geoPoint2dFieldName) !== null && _catalogItem$geoPoint !== void 0 ? _catalogItem$geoPoint : getGeoPointField(dataset);
    if (timeField && geoPointField) {
      // Get aggregation of time values for each feature (point/polygon)
      const counts = (await client.get(fromCatalog().dataset(catalogItem.datasetId).records().select("min(".concat(timeField, ") as min_time, max(").concat(timeField, ") as max_time, count(").concat(timeField, ") as num")).groupBy(geoPointField).limit(100))).records;
      if (counts) {
        pointTimeSeries = counts === null || counts === void 0 ? void 0 : counts.reduce((agg, current) => {
          var _current$record, _current$record2, _current$record3, _current$record4, _current$record5;
          const samples = current === null || current === void 0 || (_current$record = current.record) === null || _current$record === void 0 || (_current$record = _current$record.fields) === null || _current$record === void 0 ? void 0 : _current$record.num;
          const minTime = current !== null && current !== void 0 && (_current$record2 = current.record) !== null && _current$record2 !== void 0 && (_current$record2 = _current$record2.fields) !== null && _current$record2 !== void 0 && _current$record2.min_time ? new Date(current === null || current === void 0 || (_current$record3 = current.record) === null || _current$record3 === void 0 || (_current$record3 = _current$record3.fields) === null || _current$record3 === void 0 ? void 0 : _current$record3.min_time) : undefined;
          const maxTime = current !== null && current !== void 0 && (_current$record4 = current.record) !== null && _current$record4 !== void 0 && (_current$record4 = _current$record4.fields) !== null && _current$record4 !== void 0 && _current$record4.max_time ? new Date(current === null || current === void 0 || (_current$record5 = current.record) === null || _current$record5 === void 0 || (_current$record5 = _current$record5.fields) === null || _current$record5 === void 0 ? void 0 : _current$record5.max_time) : undefined;
          let intervalSec;
          if (minTime && maxTime && samples) {
            intervalSec = (maxTime.getTime() - minTime.getTime()) / (samples * 1000);
          }
          agg.push({
            samples,
            minTime,
            maxTime,
            intervalSec
          });
          return agg;
        }, []);
      }
    }
    return new OpenDataSoftDatasetStratum(catalogItem, dataset, pointTimeSeries);
  }
  duplicateLoadableStratum(model) {
    return new OpenDataSoftDatasetStratum(model, this.dataset, this.pointTimeSeries);
  }
  constructor(catalogItem, dataset, pointTimeSeries) {
    super();
    this.catalogItem = catalogItem;
    this.dataset = dataset;
    this.pointTimeSeries = pointTimeSeries;
    makeObservable(this);
  }
  get name() {
    var _this$dataset$metas$d, _this$dataset$metas;
    return (_this$dataset$metas$d = (_this$dataset$metas = this.dataset.metas) === null || _this$dataset$metas === void 0 || (_this$dataset$metas = _this$dataset$metas.default) === null || _this$dataset$metas === void 0 ? void 0 : _this$dataset$metas.title) !== null && _this$dataset$metas$d !== void 0 ? _this$dataset$metas$d : this.dataset.dataset_id;
  }
  get description() {
    var _this$dataset$metas2;
    return (_this$dataset$metas2 = this.dataset.metas) === null || _this$dataset$metas2 === void 0 || (_this$dataset$metas2 = _this$dataset$metas2.default) === null || _this$dataset$metas2 === void 0 ? void 0 : _this$dataset$metas2.description;
  }
  get metadataUrls() {
    return [createStratumInstance(MetadataUrlTraits, {
      title: i18next.t("models.openDataSoft.viewDatasetPage"),
      url: "".concat(this.catalogItem.url, "/explore/dataset/").concat(this.dataset.dataset_id, "/information/")
    })];
  }

  /** Find field to visualise by default (i.e. colorColumn)
   *  It will find the field in this order:
   * - First of type "double"
   * - First of type "int"
   * - First of type "text"
   */
  get colorFieldName() {
    var _ref, _ref2, _this$usefulFields$fi;
    return (_ref = (_ref2 = (_this$usefulFields$fi = this.usefulFields.find(f => f.type === "double")) !== null && _this$usefulFields$fi !== void 0 ? _this$usefulFields$fi : this.usefulFields.find(f => f.type === "int")) !== null && _ref2 !== void 0 ? _ref2 : this.usefulFields.find(f => f.type === "text")) === null || _ref === void 0 ? void 0 : _ref.name;
  }
  get geoPoint2dFieldName() {
    return getGeoPointField(this.dataset);
  }
  get timeFieldName() {
    return getTimeField(this.dataset);
  }
  get regionFieldName() {
    var _this$dataset$fields;
    // Find first field which matches a region type
    return (_this$dataset$fields = this.dataset.fields) === null || _this$dataset$fields === void 0 || (_this$dataset$fields = _this$dataset$fields.find(f => {
      var _this$catalogItem$mat, _this$catalogItem$mat2;
      return ((_this$catalogItem$mat = this.catalogItem.matchRegionProvider(f.name)) === null || _this$catalogItem$mat === void 0 ? void 0 : _this$catalogItem$mat.regionType) || ((_this$catalogItem$mat2 = this.catalogItem.matchRegionProvider(f.label)) === null || _this$catalogItem$mat2 === void 0 ? void 0 : _this$catalogItem$mat2.regionType);
    })) === null || _this$dataset$fields === void 0 ? void 0 : _this$dataset$fields.name;
  }
  get recordsCount() {
    var _this$dataset$metas3;
    return (_this$dataset$metas3 = this.dataset.metas) === null || _this$dataset$metas3 === void 0 || (_this$dataset$metas3 = _this$dataset$metas3.default) === null || _this$dataset$metas3 === void 0 ? void 0 : _this$dataset$metas3.records_count;
  }

  /** Number of features in timeseries */
  get pointsCount() {
    var _this$pointTimeSeries;
    return (_this$pointTimeSeries = this.pointTimeSeries) === null || _this$pointTimeSeries === void 0 ? void 0 : _this$pointTimeSeries.length;
  }

  /** Get the maximum number of samples for a given point (or sensor) */
  get maxPointSamples() {
    if (!this.pointTimeSeries) return;
    return Math.max(...this.pointTimeSeries.map(p => {
      var _p$samples;
      return (_p$samples = p.samples) !== null && _p$samples !== void 0 ? _p$samples : 0;
    }));
  }

  /** Should we select all fields (properties) in each record?
   * - Less than 10 fields
   * - Less than 10000 records
   * - There is no colorFieldName (no suitable default field - eg number - to visualise)
   * - There is no geoPoint and no time field
   *
   */
  get selectAllFields() {
    var _this$dataset$fields$, _this$dataset$fields2;
    return ((_this$dataset$fields$ = (_this$dataset$fields2 = this.dataset.fields) === null || _this$dataset$fields2 === void 0 ? void 0 : _this$dataset$fields2.length) !== null && _this$dataset$fields$ !== void 0 ? _this$dataset$fields$ : 0) <= 10 || isDefined(this.recordsCount) && this.recordsCount < 10000 || !this.catalogItem.colorFieldName || !(this.catalogItem.geoPoint2dFieldName || this.catalogItem.timeFieldName);
  }
  get selectFields() {
    if (this.selectAllFields) {
      var _this$dataset$fields$2, _this$dataset$fields3;
      // Filter out fields with GeoJSON and fields which could be lat/lon as all point information is provided with field types "geo_point" (See `getGeoPointField()`)
      return filterOutUndefined((_this$dataset$fields$2 = (_this$dataset$fields3 = this.dataset.fields) === null || _this$dataset$fields3 === void 0 ? void 0 : _this$dataset$fields3.filter(f => {
        var _f$name$toLowerCase, _f$name;
        return f.type !== "geo_shape" && !["lat", "lon", "long", "latitude", "longitude"].includes((_f$name$toLowerCase = (_f$name = f.name) === null || _f$name === void 0 ? void 0 : _f$name.toLowerCase()) !== null && _f$name$toLowerCase !== void 0 ? _f$name$toLowerCase : "");
      }).map(f => f.name)) !== null && _this$dataset$fields$2 !== void 0 ? _this$dataset$fields$2 : []).join(", ");
    }
    return filterOutUndefined([this.catalogItem.timeFieldName,
    // If aggregating time - average color field
    this.aggregateTime ? "avg(".concat(this.catalogItem.colorFieldName, ") as ").concat(this.catalogItem.colorFieldName) : this.catalogItem.colorFieldName,
    // Otherwise use region field or geopoint field (in that order)
    this.catalogItem.geoPoint2dFieldName, this.catalogItem.regionFieldName]).join(", ");
  }
  get groupByFields() {
    // If aggregating time - use RANGE group by clause to average values over a date range (eg `aggregateTime = "1 day"`)
    // See https://help.opendatasoft.com/apis/ods-search-v2/#group-by-clause
    if (this.aggregateTime && this.timeFieldName && this.geoPoint2dFieldName) {
      return "".concat(this.geoPoint2dFieldName, ",RANGE(").concat(this.timeFieldName, ", ").concat(this.aggregateTime, ") as ").concat(this.timeFieldName);
    }
  }

  // Hide geopoint column
  get geoPoint2dColumn() {
    if (this.catalogItem.geoPoint2dFieldName) {
      return createStratumInstance(TableColumnTraits, {
        name: this.catalogItem.geoPoint2dFieldName,
        type: "hidden"
      });
    }
  }

  // Set region column type
  get regionColumn() {
    if (this.catalogItem.regionFieldName) {
      return createStratumInstance(TableColumnTraits, {
        name: this.catalogItem.regionFieldName,
        type: "region"
      });
    }
  }

  // Set colour column type and title
  get colorColumn() {
    var _this$dataset$fields4;
    if (!this.catalogItem.colorFieldName) return;
    const f = (_this$dataset$fields4 = this.dataset.fields) === null || _this$dataset$fields4 === void 0 ? void 0 : _this$dataset$fields4.find(f => f.name === this.catalogItem.colorFieldName);
    if (f) {
      return createStratumInstance(TableColumnTraits, {
        name: f.name,
        title: f.label,
        type: f.type === "double" || f.type === "int" ? "scalar" : undefined
      });
    }
  }

  // Set time column type and title
  get timeColumn() {
    var _this$dataset$fields5;
    if (!this.catalogItem.timeFieldName) return;
    const f = (_this$dataset$fields5 = this.dataset.fields) === null || _this$dataset$fields5 === void 0 ? void 0 : _this$dataset$fields5.find(f => f.name === this.catalogItem.timeFieldName);
    if (f) {
      return createStratumInstance(TableColumnTraits, {
        name: f.name,
        title: f.label,
        type: "time"
      });
    }
  }

  // Set all other column types and title
  get otherColumns() {
    var _this$dataset$fields$3, _this$dataset$fields6;
    return (_this$dataset$fields$3 = (_this$dataset$fields6 = this.dataset.fields) === null || _this$dataset$fields6 === void 0 || (_this$dataset$fields6 = _this$dataset$fields6.filter(f => f.name !== this.catalogItem.timeFieldName && f.name !== this.catalogItem.colorFieldName && f.name !== this.catalogItem.regionFieldName)) === null || _this$dataset$fields6 === void 0 ? void 0 : _this$dataset$fields6.map(f => createStratumInstance(TableColumnTraits, {
      name: f.name,
      title: f.label,
      type: isIdField(f.name) ? "hidden" : undefined
    }))) !== null && _this$dataset$fields$3 !== void 0 ? _this$dataset$fields$3 : [];
  }
  get columns() {
    return filterOutUndefined([this.timeColumn, this.colorColumn, this.regionColumn, this.geoPoint2dColumn, ...(!this.selectAllFields ? [] : this.otherColumns)]);
  }

  /** Set default style traits for points (lat/lon) and time */
  get defaultStyle() {
    var _this$timeColumn;
    return createStratumInstance(TableStyleTraits, {
      regionColumn: this.regionFieldName,
      latitudeColumn: this.catalogItem.geoPoint2dFieldName && !this.catalogItem.regionFieldName ? "lat" : undefined,
      longitudeColumn: this.catalogItem.geoPoint2dFieldName && !this.catalogItem.regionFieldName ? "lon" : undefined,
      time: createStratumInstance(TableTimeStyleTraits, {
        // If we are viewing a timeseries with only 1 sample per point - spreadStart/EndTime
        spreadStartTime: isDefined(this.maxPointSamples) && this.maxPointSamples === 1,
        spreadFinishTime: isDefined(this.maxPointSamples) && this.maxPointSamples === 1,
        timeColumn: (_this$timeColumn = this.timeColumn) === null || _this$timeColumn === void 0 ? void 0 : _this$timeColumn.name,
        idColumns: this.catalogItem.geoPoint2dFieldName ? ["lat", "lon"] : undefined
      })
    });
  }

  /** Try to find a sensible currentTime based on the latest timeInterval which has values for all points
   * This is biased for real-time sensor data - where we would usually want to see the latest values.
   * As we are fetching the last 1000 records, there may be time intervals which are incomplete. Ideally we want to see all sensors with some data by default.
   */
  get currentTime() {
    var _this$catalogItem$act;
    if (!this.pointTimeSeries && this.catalogItem.geoPoint2dFieldName) return;
    const lastDate = (_this$catalogItem$act = this.catalogItem.activeTableStyle) === null || _this$catalogItem$act === void 0 || (_this$catalogItem$act = _this$catalogItem$act.timeColumn) === null || _this$catalogItem$act === void 0 ? void 0 : _this$catalogItem$act.valuesAsJulianDates.maximum;
    if (!this.catalogItem.activeTableStyle.timeIntervals || !this.catalogItem.activeTableStyle.rowGroups || !lastDate) return;

    // Group all time intervals for each row group (each Point feature)
    // This calculates the start/stop dates for each row group
    const groupIntervals = this.catalogItem.activeTableStyle.rowGroups.map(_ref3 => {
      let [_id, rows] = _ref3;
      let start;
      let stop;
      rows.forEach(rowId => {
        var _rowId;
        const interval = (_rowId = this.catalogItem.activeTableStyle.timeIntervals[rowId]) !== null && _rowId !== void 0 ? _rowId : undefined;
        if (interval !== null && interval !== void 0 && interval.start) {
          start = !start || JulianDate.lessThan(interval.start, start) ? interval.start : start;
        }
        if (interval !== null && interval !== void 0 && interval.stop) {
          stop = !stop || JulianDate.lessThan(stop, interval.stop) ? interval.stop : stop;
        }
      });
      return new TimeInterval({
        start,
        stop
      });
    });

    // Find intersection of groupIntervals - this will roughly estimate the time interval which is the "most complete" - that is to say, the time interval which has the most groups (or points) with data
    if (groupIntervals.length > 0) {
      const totalInterval = groupIntervals.reduce((intersection, current) => intersection ? TimeInterval.intersect(intersection, current) : current, undefined);

      // If intersection is found - use last date
      if (totalInterval && !totalInterval.isEmpty && !JulianDate.lessThan(lastDate, totalInterval.stop)) {
        return totalInterval.stop.toString();
      }
    }

    // If no intersection is found - use last date for entire dataset
    return lastDate.toString();
  }
  get refreshInterval() {
    if (!this.catalogItem.refreshIntervalTemplate) return;
    try {
      const string = Mustache.render(this.catalogItem.refreshIntervalTemplate, this.dataset);
      if (isJsonString(string)) {
        const timeInSeconds = (ms(string) || 0) / 1000;
        // Only return refreshInterval if less than an hour
        if (timeInSeconds < 60 * 60) {
          return timeInSeconds;
        }
      }
    } catch (e) {
      TerriaError.from(e, "Failed to parse refreshInterval from template ".concat(this.catalogItem.refreshIntervalTemplate)).log();
    }
  }

  /** Get fields with useful information (for visualisation). Eg numbers, text, not IDs, not region... */
  get usefulFields() {
    var _this$dataset$fields$4, _this$dataset$fields7;
    return (_this$dataset$fields$4 = (_this$dataset$fields7 = this.dataset.fields) === null || _this$dataset$fields7 === void 0 ? void 0 : _this$dataset$fields7.filter(f => {
      var _f$type, _f$name$toLowerCase2, _f$name2, _this$catalogItem$mat3, _this$catalogItem$mat4;
      return ["double", "int", "text"].includes((_f$type = f.type) !== null && _f$type !== void 0 ? _f$type : "") && !["lat", "lon", "long", "latitude", "longitude"].includes((_f$name$toLowerCase2 = (_f$name2 = f.name) === null || _f$name2 === void 0 ? void 0 : _f$name2.toLowerCase()) !== null && _f$name$toLowerCase2 !== void 0 ? _f$name$toLowerCase2 : "") && !isIdField(f.name) && !isIdField(f.label) && f.name !== this.catalogItem.regionFieldName && !((_this$catalogItem$mat3 = this.catalogItem.matchRegionProvider(f.name)) !== null && _this$catalogItem$mat3 !== void 0 && _this$catalogItem$mat3.regionType) && !((_this$catalogItem$mat4 = this.catalogItem.matchRegionProvider(f.label)) !== null && _this$catalogItem$mat4 !== void 0 && _this$catalogItem$mat4.regionType);
    })) !== null && _this$dataset$fields$4 !== void 0 ? _this$dataset$fields$4 : [];
  }

  /** Convert usefulFields to a Dimension (which gets turned into a SelectableDimension in OpenDataSoftCatalogItem).
   * This means we can chose which field to "select" when downloading data.
   */
  get availableFields() {
    if (!this.selectAllFields) return createStratumInstance(EnumDimensionTraits, {
      id: "available-fields",
      name: "Fields",
      selectedId: this.catalogItem.colorFieldName,
      options: this.usefulFields.map(f => ({
        id: f.name,
        name: f.label,
        value: undefined
      }))
    });
  }
  get activeStyle() {
    return this.catalogItem.colorFieldName;
  }
}, _defineProperty(_OpenDataSoftDatasetStratum, "stratumName", "openDataSoftDataset"), _OpenDataSoftDatasetStratum), _applyDecoratedDescriptor(_class.prototype, "name", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "description", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "metadataUrls", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "metadataUrls"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "colorFieldName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "colorFieldName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "geoPoint2dFieldName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoPoint2dFieldName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeFieldName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeFieldName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "regionFieldName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "regionFieldName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recordsCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recordsCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pointsCount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pointsCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxPointSamples", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxPointSamples"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAllFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectAllFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupByFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "groupByFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "geoPoint2dColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geoPoint2dColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "regionColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "regionColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "colorColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "colorColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "otherColumns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "otherColumns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "columns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "columns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultStyle"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "refreshInterval", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "refreshInterval"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "usefulFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "usefulFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeStyle"), _class.prototype), _class);

/** Column is hidden if the name starts or ends with `id` */
function isIdField() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }
  return names.filter(isDefined).reduce((hide, name) => hide || name.toLowerCase().startsWith("id") || name.toLowerCase().endsWith("id"), false);
}
function getGeoPointField(dataset) {
  var _dataset$fields;
  return (_dataset$fields = dataset.fields) === null || _dataset$fields === void 0 || (_dataset$fields = _dataset$fields.find(f => f.type === "geo_point_2d")) === null || _dataset$fields === void 0 ? void 0 : _dataset$fields.name;
}
function getTimeField(dataset) {
  var _dataset$fields2;
  return (_dataset$fields2 = dataset.fields) === null || _dataset$fields2 === void 0 || (_dataset$fields2 = _dataset$fields2.find(f => f.type === "datetime")) === null || _dataset$fields2 === void 0 ? void 0 : _dataset$fields2.name;
}
StratumOrder.addLoadStratum(OpenDataSoftDatasetStratum.stratumName);
let OpenDataSoftCatalogItem = (_class2 = (_OpenDataSoftCatalogItem = class OpenDataSoftCatalogItem extends AutoRefreshingMixin(TableMixin(UrlMixin(CreateModel(OpenDataSoftCatalogItemTraits)))) {
  constructor(id, terria, sourceReference) {
    super(id, terria, sourceReference);
    makeObservable(this);
    this.strata.set(TableAutomaticStylesStratum.stratumName, new TableAutomaticStylesStratum(this));
  }
  get type() {
    return OpenDataSoftCatalogItem.type;
  }
  async forceLoadMetadata() {
    if (!this.strata.has(OpenDataSoftDatasetStratum.stratumName)) {
      const stratum = await OpenDataSoftDatasetStratum.load(this);
      runInAction(() => {
        this.strata.set(OpenDataSoftDatasetStratum.stratumName, stratum);
      });
    }
  }
  get apiClient() {
    return new ApiClient({
      domain: this.url
    });
  }
  async forceLoadTableData() {
    var _stratum$recordsCount;
    if (!this.datasetId || !this.url) return [];
    let data = [];
    let q = fromCatalog().dataset(this.datasetId).records().limit(100);

    // If fetching time - order records by latest time
    if (this.timeFieldName) q = q.orderBy("".concat(this.timeFieldName, " DESC"));
    if (this.selectFields) {
      q = q.select(this.selectFields);
    }
    if (this.groupByFields) {
      q = q.groupBy(this.groupByFields);
    }
    const stratum = this.strata.get(OpenDataSoftDatasetStratum.stratumName);
    // Fetch maximum of 1000 records
    const recordsToFetch = Math.min(1000, (_stratum$recordsCount = stratum === null || stratum === void 0 ? void 0 : stratum.recordsCount) !== null && _stratum$recordsCount !== void 0 ? _stratum$recordsCount : 1000);

    // Get 1000 records (in chunks of 100)
    const records = flatten(await Promise.all(new Array(Math.ceil(recordsToFetch / 100)).fill(0).map(async (_v, index) => {
      var _await$this$apiClient;
      return (_await$this$apiClient = (await this.apiClient.get(q.offset(index * 100))).records) !== null && _await$this$apiClient !== void 0 ? _await$this$apiClient : [];
    })));
    if (records && records.length > 0) {
      // Set up columns object
      const cols = {};
      cols[RECORD_ID_COL] = new Array(records.length).fill("");
      if (this.geoPoint2dFieldName) {
        cols["lat"] = new Array(records.length).fill("");
        cols["lon"] = new Array(records.length).fill("");
      }
      if (this.timeFieldName) {
        cols[this.timeFieldName] = new Array(records.length).fill("");
      }
      records.forEach((record, index) => {
        var _record$record, _record$record2, _record$record$fields, _record$record3;
        if (!((_record$record = record.record) !== null && _record$record !== void 0 && _record$record.id)) return;
        // Manually add Record ID
        cols[RECORD_ID_COL][index] = (_record$record2 = record.record) === null || _record$record2 === void 0 ? void 0 : _record$record2.id;
        // Go through each field and set column value
        Object.entries((_record$record$fields = (_record$record3 = record.record) === null || _record$record3 === void 0 ? void 0 : _record$record3.fields) !== null && _record$record$fields !== void 0 ? _record$record$fields : {}).forEach(_ref4 => {
          let [field, value] = _ref4;
          // geoPoint2dFieldName will return a JSON object - spilt lat/lon columns
          if (field === this.geoPoint2dFieldName && isJsonObject(value)) {
            cols.lat[index] = "".concat(value.lat);
            cols.lon[index] = "".concat(value.lon);
          } else {
            // Copy current field into columns object
            if (!Array.isArray(cols[field])) {
              cols[field] = new Array(records.length).fill("");
            }
            cols[field][index] = "".concat(value);
          }
        });
      });

      // Munge into dataColumnMajor format
      data = Object.entries(cols).map(_ref5 => {
        let [field, values] = _ref5;
        return [field, ...values];
      });
    }
    return data;
  }
  refreshData() {
    this.forceLoadMapItems();
  }

  // Convert availableFields DimensionTraits to SelectableDimension
  get availableFieldsDimension() {
    var _this$availableFields, _this$availableFields2;
    if ((_this$availableFields = (_this$availableFields2 = this.availableFields) === null || _this$availableFields2 === void 0 || (_this$availableFields2 = _this$availableFields2.options) === null || _this$availableFields2 === void 0 ? void 0 : _this$availableFields2.length) !== null && _this$availableFields !== void 0 ? _this$availableFields : 0 > 0) {
      return {
        id: this.availableFields.id,
        name: this.availableFields.name,
        selectedId: this.availableFields.selectedId,
        options: this.availableFields.options,
        setDimensionValue: async (strataId, selectedId) => {
          this.setTrait(strataId, "colorFieldName", selectedId);
          (await this.loadMapItems()).throwIfError();
        }
      };
    }
  }
  get selectableDimensions() {
    return filterOutUndefined([this.availableFieldsDimension, ...super.selectableDimensions.filter(s => !this.availableFieldsDimension || s.id !== "activeStyle")]);
  }
}, _defineProperty(_OpenDataSoftCatalogItem, "type", "opendatasoft-item"), _OpenDataSoftCatalogItem), _applyDecoratedDescriptor(_class2.prototype, "apiClient", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "apiClient"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "availableFieldsDimension", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "availableFieldsDimension"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectableDimensions", [override], Object.getOwnPropertyDescriptor(_class2.prototype, "selectableDimensions"), _class2.prototype), _class2);
export { OpenDataSoftCatalogItem as default };
StratumOrder.addLoadStratum(TableAutomaticStylesStratum.stratumName);